import React, { useState, useEffect } from "react";
import {
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  IconButton,
  Box,
  Text,
  Flex,
  Badge,
  Button,
  Spacer,
  useToast,
  useMediaQuery,
  Collapse,
} from "@chakra-ui/react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { server } from "../util/connect";
import { useAuth } from "../auth/AuthProvider";
import { ArrowForwardIcon, DeleteIcon, EditIcon, TimeIcon } from "@chakra-ui/icons";
import "../css/CustomTable.css";
import DoctorDeleteModal from "./modals/DoctorDeleteModal";
import { getValidDays } from "../util/calendar_util";
import DoctorProfileModal from "./modals/DoctorProfileModal";
import { FaPlusCircle } from "react-icons/fa";

function DoctorListPage({}) {
  const [doctors, setDoctors] = useState([]);
  const navigate = useNavigate();
  const { user } = useAuth();
  const toast = useToast();
  const [isMobile] = useMediaQuery("(max-width: 768px)"); // Check if mobile screen

  const [selectedDeleteDoctor, setSelectedDeleteDoctor] = useState(null);
  const [isDeleteModalOpen, setDeleteModalOpen] = useState(false);

  const [isDoctorProfileModalOpen, setDoctorProfileModalOpen] = useState(false);
  const [selectedDoctorProfile, setSelectedDoctorProfile] = useState(null);
  const [openCollapse, setOpenCollapse] = useState(false);

  const openDoctorProfileModal = (user) => {
    setSelectedDoctorProfile(user);
    setDoctorProfileModalOpen(true);
  };

  const closeDoctorProfileModal = () => {
    setSelectedDoctorProfile(null);
    setDoctorProfileModalOpen(false);
  };

  useEffect(() => {
    if (user && user.department_id) {
      fetchData();
    }
  }, [user]);

  const fetchData = async () => {
    const result = await axios.post(
      `${server}/timetable/list_doctor_timetable`,
      { department_id: user.department_id }
    );
    setDoctors(result.data);
  };

  const handleDoctorTimetableInfo = (doctor) => {
    navigate(`/doctor/${doctor.id}`);
  };

  const getStatusColor = (status) => {
    if (status == "active") return "green";
    if (status == "inactive") return "orange";
    return "red";
  };

  const getGenderText = (gender) => {
    if (gender == "M") return "ชาย";
    if (gender == "F") return "หญิง";
    if (gender == "not specified") return "ไม่ระบุ";
    return "ไม่ระบุ";
  };

  const handleDeleteDoctor = async () => {
    try {
      await axios.post(`${server}/timetable/delete_doctor`, {
        doctor_id: selectedDeleteDoctor.id,
      });
      setDeleteModalOpen(false);
      fetchData();
    } catch (error) {
      console.error("Error deleting doctor:", error);
    }
  };

  const openDeleteModal = (doctor) => {
    setSelectedDeleteDoctor(doctor);
    setDeleteModalOpen(true);
  };

  const handleDoctorProfileSubmit = async (userData) => {
    console.log("User Data:", userData);
    try {
      // Use axios to send a POST request to your Node.js server
      const response = await axios.post(
        `${server}/timetable/save_doctor_profile`,
        { ...userData, department_id: user.department_id }
      );

      if (response.data.status === "success") {
        toast({
          title: "บันทึกข้อมูลเรียบร้อย",
          status: "success",
          duration: 3000,
          isClosable: true,
        });
        fetchData();
      } else if (response.data.status === "user_exist") {
        toast({
          title: "มีแพทย์ชื่อนี้อยู่ในระบบแล้ว (ไม่สามารถบันทึกข้อมูลได้)",
          status: "warning",
          duration: 3000,
          isClosable: true,
        });
      } else {
        toast({
          title: response.data.error,
          status: "error",
          duration: 3000,
          isClosable: true,
        });
      }
    } catch (error) {
      toast({
        title: error.message,
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    }
  };

  return (
    <Box display="flex" alignItems="center" justifyContent="center">
      <Box
        w={"1300px"}
        overflowX="auto"
        css={{
          "&::-webkit-scrollbar": {
            height: "6px",
          },
          "&::-webkit-scrollbar-thumb": {
            background: "#a0aec0",
          },
        }}
      >
        <Box position="relative" alignItems="center" justifyContent="center">
          <Flex justify={"space-between"} align={"center"} mb={2}>
            <Text fontSize={15} fontWeight={600}>
              รายชื่อแพทย์ {user && user.department}
            </Text>
            <Spacer />
            <Button leftIcon={<FaPlusCircle/>} size={"sm"} colorScheme="green" variant={"outline"} onClick={() => openDoctorProfileModal(null)}>
              เพิ่มแพทย์
            </Button>
          </Flex>
          {isMobile ? ( // Render as cards on mobile
            <Box>
              {doctors.map((doctor) => (
                <Box
                  key={doctor.id}
                  mb={4}
                  p={2}
                  borderWidth="1px"
                  rounded="md"
                >
                  <Box borderWidth="1px">
                    <Flex borderBottom="1px solid #E2E8F0">
                      <Text
                        fontSize="sm"
                        p={1}
                        bgColor={"blue.50"}
                        width={110}
                        fontWeight="bold"
                        mr={2}
                      >
                        แพทย์:
                      </Text>
                      <Text
                        fontSize="sm"
                        p={1}
                      >{`${doctor.first_name} ${doctor.last_name}`}</Text>
                    </Flex>
                    <Flex borderBottom="1px solid #E2E8F0">
                      <Text
                        fontSize="sm"
                        p={1}
                        bgColor={"blue.50"}
                        width={110}
                        fontWeight="bold"
                        mr={2}
                      >
                        วันออกตรวจ:
                      </Text>
                      <Text fontSize="sm" p={1}>
                        {getValidDays(doctor.diagnosisTimes)}
                      </Text>
                    </Flex>
                    <Flex borderBottom="1px solid #E2E8F0">
                      <Text
                        fontSize="sm"
                        p={1}
                        bgColor={"blue.50"}
                        width={110}
                        fontWeight="bold"
                        mr={2}
                      >
                        เพศ:
                      </Text>
                      <Text fontSize="sm" p={1}>
                        {getGenderText(doctor.gender)}
                      </Text>
                    </Flex>
                    <Flex borderBottom="1px solid #E2E8F0">
                      <Text
                        fontSize="sm"
                        p={1}
                        bgColor={"blue.50"}
                        minW={110}
                        fontWeight="bold"
                        mr={2}
                      >
                        สถานะ:
                      </Text>
                      <Text
                          fontSize="sm"
                          p={1}
                          color={getStatusColor(doctor.status)}
                        >
                          {doctor.status}
                        </Text>
                    </Flex>
                  </Box>
                  <Flex justify={"space-between"} mt={2}>
                    <Button
                      onClick={() => setOpenCollapse((prevState) => !prevState)}
                      size={"sm"}
                      variant="link"
                    >
                      {openCollapse ? "ปิด" : "แก้ไข/ลบ"}
                    </Button>
                    <Spacer/>
                    {!doctor.is_non_doctor && (
                          <Button
                            colorScheme="blue"
                            variant='link'
                            size={"xs"}
                            onClick={() => handleDoctorTimetableInfo(doctor)}
                            rightIcon={<ArrowForwardIcon />}
                          >
                            แสดงเวลาตรวจ
                          </Button>
                        )}
                  </Flex>
                  <Collapse in={openCollapse} animateOpacity>
                    <Flex
                      mt={2}
                      justify={"start"}
                    >
                      {!doctor.is_non_doctor && (
                        <IconButton
                          bgColor="gray.200"
                          color="green.500"
                          ml={2}
                          aria-label="แก้ไขข้อมูลแพทย์"
                          icon={<EditIcon />}
                          size="md"
                          onClick={() => openDoctorProfileModal(doctor)}
                        />
                      )}
                      <IconButton
                        bgColor="gray.200"
                        color="red.500"
                        ml={2}
                        aria-label="ลบแพทย์"
                        icon={<DeleteIcon />}
                        size="md"
                        onClick={() => openDeleteModal(doctor)}
                      />
                    </Flex>
                  </Collapse>
                </Box>
              ))}
              {(!doctors || doctors.length <= 0) && <Text>ไม่มีรายการ</Text>}
            </Box>
          ) : (
            <Table className="custom-table">
              <Thead>
                <Tr>
                  <Th>แพทย์</Th>
                  <Th>วันออกตรวจ</Th>
                  <Th>เพศ</Th>
                  <Th>สถานะ</Th>
                  <Th>Actions</Th>
                </Tr>
              </Thead>
              <Tbody>
                {doctors.map((doctor) => (
                  <Tr key={doctor.id}>
                    <Td
                      minW={"120px"}
                    >{`${doctor.first_name} ${doctor.last_name}`}</Td>
                    <Td>{getValidDays(doctor.diagnosisTimes)}</Td>
                    <Td w={"150px"}>{getGenderText(doctor.gender)}</Td>
                    <Td w={"150px"}>
                      <Badge colorScheme={getStatusColor(doctor.status)}>
                        {doctor.status}
                      </Badge>
                    </Td>
                    <Td minW={"200px"} w={"200px"}>
                      {doctor.is_non_doctor == 0 && (
                        <IconButton
                          bgColor="gray.200"
                          color="blue.500"
                          aria-label={"แก้ไขเวลาออกตรวจ"}
                          icon={<TimeIcon />}
                          size="md"
                          onClick={() => handleDoctorTimetableInfo(doctor)}
                        />
                      )}

                      {doctor.is_non_doctor == 0 && (
                        <IconButton
                          bgColor="gray.200"
                          color="green.500"
                          ml={2}
                          aria-label={"แก้ไขข้อมูลแพทย์"}
                          icon={<EditIcon />}
                          size="md"
                          onClick={() => openDoctorProfileModal(doctor)}
                        />
                      )}

                      <IconButton
                        bgColor="gray.200"
                        color="red.500"
                        ml={2}
                        aria-label={"ลบแพทย์"}
                        icon={<DeleteIcon />}
                        size="md"
                        onClick={() => openDeleteModal(doctor)}
                      />
                    </Td>
                  </Tr>
                ))}

                {(!doctors || doctors.length <= 0) && (
                  <Tr>
                    <Td colSpan={5}>ไม่มีรายการ</Td>
                  </Tr>
                )}
              </Tbody>
            </Table>
          )}
        </Box>
      </Box>

      <DoctorDeleteModal
        isDeleteModalOpen={isDeleteModalOpen}
        setDeleteModalOpen={setDeleteModalOpen}
        handleDeleteDoctor={handleDeleteDoctor}
        selectedDeleteDoctor={selectedDeleteDoctor}
      />

      <DoctorProfileModal
        isOpen={isDoctorProfileModalOpen}
        onClose={closeDoctorProfileModal}
        onSubmit={handleDoctorProfileSubmit}
        user={selectedDoctorProfile}
      />
    </Box>
  );
}

export default DoctorListPage;
